export const queryKeys = {
  getOrganizations: "getOrganizations",
  getOrganization: "getOrganization",
  getOrganizationLookups: "getOrganizationLookups",
  getState: "getState",
};
